import { CheckoutPaymentMethod } from "../PaymentMethod.ts";
import {
  CheckoutMethodConfigDTO,
  PaymentMethodStepConfig,
} from "./PaymentMethodStepInterface.ts";
import {
  CardOneTimePaymentStepConfig,
  CardInstallmentPaymentStepConfig,
} from "./Card/CardPaymentStepConfig.tsx";
import { HeyLightPaymentStepConfig } from "./HeyLight/HeyLightPaymentStepConfig.tsx";

export const paymentStepRegistry: Record<
  CheckoutPaymentMethod,
  PaymentMethodStepConfig
> = {
  [CheckoutPaymentMethod.StripeOneTime]: CardOneTimePaymentStepConfig,
  [CheckoutPaymentMethod.StripeInstallments]: CardInstallmentPaymentStepConfig,
  [CheckoutPaymentMethod.HeyLight]: HeyLightPaymentStepConfig,
};

export function getPaymentStepConfig(
  method: CheckoutPaymentMethod,
): PaymentMethodStepConfig | undefined {
  return paymentStepRegistry[method];
}

export function getAvailablePaymentMethodsForItem(
  item: CheckoutMethodConfigDTO,
): CheckoutPaymentMethod[] {
  return Object.values(paymentStepRegistry)
    .filter((config) => config.isAvailableForItem(item))
    .map((config) => config.method);
}
